// ライブラリ
import merge from 'deepmerge'
import { objectToGet, isObject } from '../../functions/index'

class StoreBase {
  constructor() {
    this.store = {}
  }

  /**
   * state // データの取得
   */
  state(name = '', defaultValue = {}) {
    return this.get(this.store, name, defaultValue)
  }

  /**
   * trigger // コントローラーのトリガーを引く
   *
   * @param {string} name // トリガー名
   */
  trigger(name) {
    window.controller.trigger(name)
  }

  /**
   * set // データのセット
   *
   * @param {string} name
   * @param {any} data
   */
  set(name, data = null) {
    const object = isObject(data)
    if (object) this.store[name] = merge(this.store[name], data)
    if (!object) this.store[name] = data
  }

  /**
   * get. // オブジェクトから値を取得する
   *
   * @param {object} object
   * @param {string} name
   * @param {any} defaultValue
   */
  get(object, name, defaultValue) {
    return objectToGet(object, name, defaultValue)
  }

  /**
   * merge // データのマージ
   *
   * @param {any} data
   */
  merge(data = null) {
    const isObject = typeof data === 'object'
    if (isObject) this.store = merge(this.store, data)
    if (!isObject) this.store = data
  }

  /**
   * updateFormValue // formストアの変更をストアに伝搬
   *
   * @param {string} value
   * @param {string} name
   */
  updateFormValue(value, name) {
    this.set(name, value)
    // console.log('フォーム値', value)
    // console.log('フォーム名', name)
  }
}

export default StoreBase
